import { defineComponent as _defineComponent } from 'vue'
import { useFormattedChanges } from './composables/useFormattedChanges'
import JobHistory from '@/models/job-history'
import ActivityLogItem from './ActivityLogItem.vue'

// Define your props

export default /*#__PURE__*/_defineComponent({
  __name: 'JobHistoryDaySection',
  props: {
    date: null,
    changes: { default: () => [] },
    jobStart: { default: null },
    jobEnd: { default: null },
    jobHubId: null
  },
  setup(__props: any) {

const props = __props as { date: string | number, changes: JobHistory[], jobStart: object | null, jobEnd: object | null, jobHubId: string }



const { formattedDate, formattedChanges } = useFormattedChanges(props)

return { __sfc: true,props, formattedDate, formattedChanges, ActivityLogItem }
}

})